module.exports = __webpack_public_path__ + "img/7.ddc0fd57.png";